// extracted by mini-css-extract-plugin
export default {"buttonContainer":"LicenceModal_buttonContainer__s2WrS","uploadButton":"LicenceModal_uploadButton__CpMFQ"};